import { Typography } from '@material-ui/core'
import React from 'react'

import { addCommaToPrice } from '../../helpers/numbers'
import { formatPromotionMinorAmount } from '../../helpers/promotion'
import { getTranslate } from '../../localization'
import { Currency } from '../../types/currency'
import { useStyles } from './styles/index.styles'

type MajorUnitPrice = {
  value: number
  currency: Currency
  minorAmount?: never
}

type MinorUnitPrice = {
  minorAmount: string
  currency: string
  value?: never
}

type PriceRowProps = (MajorUnitPrice | MinorUnitPrice) & {
  label: string
  translateLabel?: boolean
  isDiscount?: boolean
  bold?: boolean
}
export const PriceRow: React.FC<PriceRowProps> = ({
  label,
  value,
  minorAmount,
  currency,
  translateLabel = true,
  isDiscount = false,
  bold
}) => {
  const classes = useStyles()
  const formattedValue =
    minorAmount !== undefined
      ? formatPromotionMinorAmount(minorAmount, currency)
      : addCommaToPrice(value)

  return (
    <div className={classes.row}>
      <Typography
        variant="h6"
        className={[classes.mainText, bold ? classes.boldText : ''].join(' ')}>
        {translateLabel ? getTranslate(label) : label}
      </Typography>
      <Typography
        variant="h6"
        className={[
          classes.mainText,
          bold && classes.boldText,
          isDiscount && classes.greenText,
          classes.rightText
        ].join(' ')}>
        {`${formattedValue} ${getTranslate(currency || '')}`}
      </Typography>
    </div>
  )
}
